import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Button } from 'ui-components/components/button';
import { messages } from '../messages/general-export-messages';
import { DeleteFormatModal } from './delete-format-modal';

import style from '../export-records-modal.module.less';

export const ExportFormatItem = ({ format, onFormatTypeChanged, onDeleteFormat, onEditFormat, isChecked = false }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const onDeleteButtonClick = useCallback(() => {
    setIsDeleteModalOpen(true);
  }, [setIsDeleteModalOpen]);
  const closeDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
  }, [setIsDeleteModalOpen]);
  const onDeleteExportFormat = useCallback(() => {
    onDeleteFormat(format.extractId);
  }, [onDeleteFormat, format]);
  return (
    <RadioCheckListItem
      key={format.extractId}
      className={style['option-row']}
      isChecked={isChecked}
      onChecked={() => onFormatTypeChanged(format.extractId)}
    >
      <div className={style['option-name']}>{format.name}</div>
      <div className={style['option-actions']}>
        <Button onClick={() => onEditFormat(format)} theme='link'>
          <FormattedMessage {...messages.editFormat} />
        </Button>
        <div className={style['trash-wrapper']} onClick={onDeleteButtonClick}>
          <FontAwesomeIcon icon={faTrash} />
          {isDeleteModalOpen && <DeleteFormatModal onClose={closeDeleteModal} onDeleteExportFormat={onDeleteExportFormat} />}
        </div>
      </div>
    </RadioCheckListItem>
  );
};

ExportFormatItem.propTypes = {
  format: PropTypes.shape({
    extractId: PropTypes.string,
    extractType: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onFormatTypeChanged: PropTypes.func.isRequired,
  onDeleteFormat: PropTypes.func.isRequired,
  onEditFormat: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
};
